/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import ValueColumn from "./ValueColumn";
import UnitColumn from "./UnitColumn";
import {RowCell} from "../../atoms/layout/RowCell";
import {QuantityInput} from "../../atoms/forms/QuantityInput";
import {AddToCartButton} from "../../atoms/bootstrap/Button";
import * as React from "react";
import {useI18N} from "../../hoc/withI18N";
import * as PropTypes from "prop-types";
import {SKU} from "../../../data/mypuratos";
import {FormatProductPackaging} from "../../atoms/helper/FormatProductPackaging";
import {StockInformation} from "../../atoms/details/StockInformation";
import {MobileOnly} from "../../my-puratos/atoms/table/Table";

const addAllSizing = {xxs: 6, xs: 6, sm: 4};
const normalSizing = {xxs: 6, xs: 6, sm: 3};

export function ProductDetailsColumns({ sku, addToCart, quantity, updateQuantity, isLoading, response, cartQuantity = 0,
                                          packagingOptions, setSkuPackaging, addAll, hideCartAmountAlert, showStock }) {

    const translate = useI18N();

    return <React.Fragment>
        {packagingOptions && packagingOptions.length > 1 ?
            <UnitColumn label={translate("Unit")} current={sku} options={packagingOptions}
                        setOption={setSkuPackaging} sizes={addAll ? addAllSizing : normalSizing} className={`p-flex-align-end-desktop-important`}/> :
            <ValueColumn label={translate("Unit")}
                         value={<FormatProductPackaging sku={sku}/>}
                         sizes={addAll ? addAllSizing : normalSizing} className={`p-flex-align-end-desktop-important`}/>}
        <ValueColumn label={translate("Unit price")}
                     value={sku.totalUnitPrice}
                     altValue={sku.promotionTotalPrice ? sku.promotionTotalPrice : undefined}
                     sizes={addAll ? addAllSizing : normalSizing} className={`p-flex-align-end-desktop-important`}/>
        {showStock && <MobileOnly size={"760px"}>
            <StockInformation type={sku.stockType} showTooltip={false} className={"mobile-row p-margin-bottom-sm"}/>
        </MobileOnly>}
        <RowCell className={(addAll ? "col-xxs-12 col-xs-12 col-sm-4" : "col-xxs-6 col-xs-6 col-sm-3") + " is-last table-group-cell__input p-flex-justify-content-end-desktop-important"}>
            <QuantityInput min={Math.max(1, sku.minimumOrderableQuantity - cartQuantity)}
                           disabled={isLoading || sku.stockType === "BLOCKSALE"} updateValue={updateQuantity} value={quantity}/>
        </RowCell>
        {!addAll && addToCart && <RowCell className={"col-xxs-6 col-xs-6 col-sm-3 is-last p-flex p-align-self-center-sm p-flex-justify-content-end-desktop-important"}>
            <AddToCartButton loading={isLoading} disabled={!quantity || isLoading || sku.stockType === "BLOCKSALE"} onClick={addToCart}
                             response={response} small/>
        </RowCell>}
        {!hideCartAmountAlert && cartQuantity > 0 && sku.materialNumber && <RowCell className={"col-xxs-12 p-align-self-center-sm"}>
            <div className="product-detail-cart-quantity">
                <span className="p-sans p-tiny">
                    {translate("You currently have {0} in your cart").replace("{0}", cartQuantity)}
                </span>
            </div>
        </RowCell>}
    </React.Fragment>
}

ProductDetailsColumns.propTypes = {
    sku: PropTypes.shape(SKU),
    quantity: PropTypes.number,
    addToCart: PropTypes.func,
};

ProductDetailsColumns.defaultProps = {
    quantity: 0,
};
